import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import '../../styles/projectcss/Residential.css';

// Import religious project images
import religious2 from '../../assets/images/projects/Religious/2.jpg';
import religious3 from '../../assets/images/projects/Religious/3.png';
import religious1 from '../../assets/images/projects/Religious/1.png';
import religious4 from '../../assets/images/projects/Religious/4.jpg';
import religious5 from '../../assets/images/projects/Religious/5.jpg';
import religious6 from '../../assets/images/projects/Religious/6.png';
import religious7 from '../../assets/images/projects/Religious/7.png';
import religious8 from '../../assets/images/projects/Religious/8.png';
import religious9 from '../../assets/images/projects/Religious/9.png';
import religious10 from '../../assets/images/projects/Religious/10.png';
import religious11 from '../../assets/images/projects/Religious/11.png';
import religious12 from '../../assets/images/projects/Religious/12.png';
import religious13 from '../../assets/images/projects/Religious/13.png';
import religious14 from '../../assets/images/projects/Religious/14.png';
import religious15 from '../../assets/images/projects/Religious/15.png';
import religious16 from '../../assets/images/projects/Religious/16.png';
import religious17 from '../../assets/images/projects/Religious/17.png';
import religious18 from '../../assets/images/projects/Religious/18.png';



const Religious = () => {
  const [imageLoading, setImageLoading] = useState({});
  const navigate = useNavigate();

  const religiousProjects = [
    { id: 1, image: religious1 },
    { id: 2, image: religious2 },
    { id: 3, image: religious3 },
    { id: 4, image: religious4 },
    { id: 5, image: religious5 },
    { id: 6, image: religious6 },
    { id: 7, image: religious7 },
    { id: 8, image: religious8 },
    { id: 9, image: religious9 },
    { id: 10, image: religious10 },
    { id: 11, image: religious11 },
    { id: 12, image: religious12 },
    { id: 13, image: religious13 },
    { id: 14, image: religious14 },
    { id: 15, image: religious15 },
    { id: 16, image: religious16 },
    { id: 17, image: religious17 },
    { id: 18, image: religious18 }
  ];

  const projectHighlights = [
    {
      title: "Spiritual Design",
      description: "Our religious structures are designed with deep respect for Islamic architecture, incorporating traditional elements with modern functionality for spiritual comfort.",
      icon: "🕌"
    },
    {
      title: "Community Focus",
      description: "We create religious spaces that serve as community hubs, fostering unity, spiritual growth, and social cohesion among worshippers.",
      icon: "🤲"
    },
    {
      title: "Sacred Craftsmanship",
      description: "Every religious project is built with meticulous attention to detail, using quality materials and traditional craftsmanship to create spaces worthy of worship.",
      icon: "✨"
    }
  ];

  const handleImageLoad = (projectId) => {
    setImageLoading(prev => ({ ...prev, [projectId]: false }));
  };

  const handleImageError = (projectId) => {
    setImageLoading(prev => ({ ...prev, [projectId]: false }));
  };

  const handleInquireProject = (project) => {
    navigate('/contact', { 
      state: { 
        selectedService: "Religious Project",
        projectDetails: project
      }
    });
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0, scale: 0.9 },
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  const filterVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 200
      }
    }
  };

  return (
    <motion.div 
      className="residential-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <div className="container">
        <motion.div className="residential-header" variants={itemVariants}>
          <h1>Religious Projects</h1>
          <p className="page-intro">
            Explore our sacred portfolio of mosques and Islamic centers, built with spiritual reverence 
            and architectural excellence to serve communities and honor Islamic traditions.
          </p>

          <motion.div 
            className="projects-filter"
            variants={filterVariants}
          >
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/projects')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              All Projects
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/residential')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Residential
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/commercial')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Commercial
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/industrial')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Industrial
            </motion.button>
            <motion.button
              className={`filter-btn ${'religious' === 'religious' ? 'active' : ''}`}
              onClick={() => navigate('/religious')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Religious
            </motion.button>
            {/* <motion.button
              className="filter-btn"
              onClick={() => navigate('/infrastructure')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Infrastructure
            </motion.button> */}
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/educational')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Educational
            </motion.button>
            <motion.button
              className="filter-btn"
              onClick={() => navigate('/road')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Road
            </motion.button>
          </motion.div>
        </motion.div>

        <motion.section className="gallery-section" variants={itemVariants}>
          <h2>Project Gallery</h2>
          <p className="section-subtitle">A showcase of our spiritually inspired religious constructions</p>
          <div className="gallery-grid">
            {religiousProjects.map((project, index) => (
              <motion.div
                key={project.id}
                className={`gallery-item gallery-item-${index + 1}`}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <div className="gallery-image">
                  <img 
                    src={project.image} 
                    alt={`Religious Project ${project.id}`}
                    onLoad={() => handleImageLoad(`gallery-${project.id}`)}
                    onError={() => handleImageError(`gallery-${project.id}`)}
                  />
                  <div className="gallery-overlay">
                    {/* <div className="gallery-info">
                      <motion.button 
                        className="inquire-btn"
                        onClick={() => handleInquireProject(project)}
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                      >
                        Inquire Now
                      </motion.button>
                    </div> */}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.section>

        <motion.section className="highlights-section" variants={itemVariants}>
          <h2>Why Choose Our Religious Projects</h2>
          <div className="highlights-grid">
            {projectHighlights.map((highlight, index) => (
              <motion.div
                key={index}
                className="highlight-card"
                whileHover={{ y: -10, transition: { type: "spring", stiffness: 300 } }}
              >
                <div className="highlight-icon">{highlight.icon}</div>
                <h3>{highlight.title}</h3>
                <p>{highlight.description}</p>
              </motion.div>
            ))}
          </div>
        </motion.section>

        <motion.section className="cta-section" variants={itemVariants}>
          <div className="cta-content">
            <h2>Ready to Build Your Religious Space?</h2>
            <p>Let's discuss your religious construction needs and create a sacred space that serves your community with dignity and beauty.</p>
            <motion.button 
              className="cta-button"
              onClick={() => navigate('/contact')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Start Your Project
            </motion.button>
          </div>
        </motion.section>
      </div>
    </motion.div>
  );
};

export default Religious;